import { styled, css } from '@mui/material';

const DestructiveVariant = theme => css`
  color: ${theme.palette.redBase};
`;
const Title = styled('div')(_ref => {
  let {
    theme,
    variant
  } = _ref;
  return [theme.typography.heading, variant === 'destructive' && DestructiveVariant(theme)];
});
const Text = styled('div')(_ref2 => {
  let {
    theme
  } = _ref2;
  return [theme.typography.body01, css`
    color: ${theme.palette.text.primary};
    min-height: 96px;

    ${theme.breakpoints.down('md')} {
      min-height: auto;
    }
  `];
});

export { Text, Title };
